import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Cargando from '../../Varios/Cargando';
import { ObtenerInformacionSolicitudes, RechazarParcialmenteSolicitudPermisos, RechazarSolicitudPermisos, ValidarSolicitudLicencias, ValidarSolicitudPermisos, VistaPreviaSolicitudLicencias } from './FunctionsAprobacionesTh';
import { SolicitudesPermisosPorAprobarTH } from './TypesAprobacionesSolicitudes';
import TablaAprobacionSolicitudesTh from './TablaAprobacionSolicitudesTh';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';

import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import ModalRechazo from 'components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud';
import { alertService } from 'components/Varios/alert_service';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ResponseRequest } from 'components/Types/GeneralTypes';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import Swal from 'sweetalert2';

import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"
import AnuncioSVG from "assets/icons/Permisos/Anuncio.svg"

type StateAprobacionSolicitudes = {
    filasTabla: SolicitudesPermisosPorAprobarTH[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    mensajeError: string | undefined,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalInformacionValidarPermisos = {
    url: string,
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    tituloModal: string
}

type StateModalInformacionRechazar = {
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    observacion: string
}

export function showAlertSwal(message:string, isSuccess:boolean) {
    Swal.fire({
        text: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertSwalAnuncio(message:string) {
    Swal.fire({
        text: message,
        imageUrl: `${AnuncioSVG}`, 
        imageHeight: 100, // Ajusta el tamaño según sea necesario
        imageAlt: "Anuncio",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}



export function showAlertHTMLSwal(message:string, isSuccess:boolean) {
    Swal.fire({
        html: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}



export default function AprobacionSolicitudesTh() {
    const TITULO_APROBACION_SOLICITUDES = "ELABORACIÓN DE AP DE LICENCIAS / VALIDACIÓN DE PERMISOS";

    const defaulState: StateAprobacionSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        mensajeError: undefined,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateModalInformacionValidarPermisos: StateModalInformacionValidarPermisos = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        tituloModal: "Solicitud Permisos"
    }

    const defaultStateModalInformacionValidarLicencias: StateModalInformacionValidarPermisos = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        tituloModal: "Solicitud Licencias"
    }

    const defaultStateModalInformacionRechazar: StateModalInformacionRechazar = {
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        observacion: ""
    }

    
    const [stateAprobacion, setstateAprobacion] = useState<StateAprobacionSolicitudes>(defaulState)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)


    const [stateinformacionModalAprobarPermisos, setstateinformacionModalAprobarPermisos] = useState(defaultStateModalInformacionValidarPermisos)
    const [stateinformacionModalAprobarLicencias, setstateinformacionModalAprobarLicencias] = useState(defaultStateModalInformacionValidarLicencias)
    const [stateinformacionModalRechazar, setstateinformacionModalRechazar] = useState(defaultStateModalInformacionRechazar)
    const [stateinformacionModalRechazarParcial, setstateinformacionModalRechazarParcial] = useState(defaultStateModalInformacionRechazar)

    
    const [observacion, setobservacion] = useState("")

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function ObtenerDatosSolicitudes() {  
        setstateAprobacion({ ...stateAprobacion, loadingFilas: true })
        const resultado = await ObtenerInformacionSolicitudes()
        if (resultado.status === 200) {
            if (typeof (resultado.dataResponse) === "string") {
                setstateAprobacion({ ...stateAprobacion, mensajeAprobacion: resultado.dataResponse, loadingFilas: false })
            }
            else {  
                setstateAprobacion({ ...stateAprobacion, filasTabla: resultado.dataResponse, loadingFilas: false })
            }

        } else {
            setstateAprobacion(prev => ({ ...prev, mensajeError: resultado.errorMessage, loadingFilas: false, errorFilas: true }));
           
        }
        
    }
        
    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])

    useEffect(() => {
        ObtenerDatosSolicitudes();      
    }, [])

    async function OnCloseModalRechazo() {
        setstateinformacionModalRechazar(defaultStateModalInformacionRechazar)
        setstateinformacionModalRechazarParcial(defaultStateModalInformacionRechazar)
        await ObtenerDatosSolicitudes()
        ScrollToTop();

    }

    async function OnCloseModalValidacion() {
        setstateinformacionModalAprobarLicencias(defaultStateModalInformacionValidarPermisos)
        setstateinformacionModalAprobarPermisos(defaultStateModalInformacionValidarPermisos)
        await ObtenerDatosSolicitudes()
        ScrollToTop();

    }


    const tablaSolicitudes = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla , mensajeError} = stateAprobacion
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas && mensajeError === undefined) {
            return <div>No ha sido posible cargar la información</div>
        }else if (!loadingFilas && errorFilas && mensajeError) {
            return <div className="alert alert-danger">{mensajeError}</div>;
        }
        else if (filasTabla.length > 0) {
            return (
                <TablaAprobacionSolicitudesTh 
                    dataFilas={stateAprobacion.filasTabla}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickRechazar = {(solicitud: any) => onClickRechazarSolicitudPermisos(solicitud)}
                    onClickRechazarParcial = {(solicitud: any) => onClickRechazarSolicitudParcialPermisos(solicitud)}
                    onClickValidar = {(solicitud: any) => onClickAprobarParcialmenteSolicitudPermisos(solicitud)}
                />
                
            )

        }
        else {
            return (
                <TablaAprobacionSolicitudesTh
                    dataFilas={[]}
                    onClickVerDocumento={async (referencia: string) => {;}}
                    onClickRechazar = {(solicitud: any) => {;}}
                    onClickRechazarParcial = {(solicitud: any) => {;}}
                    onClickValidar = {(solicitud: any) => {;}}
                />
            )
        }

    }, [stateAprobacion])

    function AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones): any {
        return(
                <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Horario Solicitud </th>                            
                            <th> Días </th>
                            <th> Horas </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaInicio)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaFin)}
                                </div>

                            </td>
                            {/* Celda unificada para horas */}
                            <td className="">
                                <div className="">
                                    {/* Bloque Mañana */}
                                    <div className="">                                        
                                        <div>{informacionAcciones.horaInicio} - {informacionAcciones.horaFin}</div>
                                    </div>
                                    {/* Bloque Tarde */}
                                    {informacionAcciones.horaInicioTarde && informacionAcciones.horaFinTarde && (
                                        <div className="">                                            
                                            <div>{informacionAcciones.horaInicioTarde} - {informacionAcciones.horaFinTarde}</div>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.tiempo}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.horasDif}
                                </div>
                            </td>


                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>

                            </td>

                        </tr>

                    </tbody>
                </Table>
                </>
        )
    }

    function onClickRechazarSolicitudPermisos(informacionAcciones) {

        const modalContent = AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones);

        setstateinformacionModalRechazar({
            cargando: false,
            idSolicitud: informacionAcciones.idPermiso,
            modalContent,
            observacion
        })
    }

    

    async function RechazarPermisos(idSolicitud, observacion) {
        const respuesta = await RechazarSolicitudPermisos(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            //alertService.error(respuesta.errorMessage)
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
            OnCloseModalRechazo()
            return 1;
        }
        else {
            //alertService.success("Se ha negado la solicitud de permiso y/o licencia");
            await showAlert("Se ha negado la solicitud de permiso y/o licencia", ExitoSVG, true);
            OnCloseModalRechazo()
            return -1

        }
    }

    async function RechazarParcialPermisos(idSolicitud, observacion) {
        const respuesta = await RechazarParcialmenteSolicitudPermisos(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            //alertService.error(respuesta.errorMessage)
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
            OnCloseModalRechazo()
            return 1;
        }
        else {
            //alertService.success("Se ha negado parcialmente la solicitud de permiso y/o licencia");
            await showAlert("Se ha negado parcialmente la solicitud de permiso y/o licencia", ExitoSVG, true);
            OnCloseModalRechazo()
            return -1;
        }
    }

    function onClickRechazarSolicitudParcialPermisos(informacionAcciones) {

        const modalContent = AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones);

        setstateinformacionModalRechazarParcial({
            cargando: false,
            idSolicitud: informacionAcciones.idPermiso,
            modalContent,
            observacion
        })
    }


    async function onClickAprobarParcialmenteSolicitudPermisos(informacionAcciones) {
        if (informacionAcciones.idTipoPermiso == 5 || informacionAcciones.idTipoPermiso == 29 || informacionAcciones.idTipoPermiso == 36 || informacionAcciones.idTipoPermiso == 37 || informacionAcciones.idTipoPermiso == 18){
            const modalContent = AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones);
            const tituloModal = "Validación Solicitud de "+informacionAcciones.tipoPermiso
            setstateinformacionModalAprobarPermisos({
                url:"",
                cargando: false,
                idSolicitud: informacionAcciones.idPermiso,
                modalContent,
                tituloModal: tituloModal
            })
        }
        if (informacionAcciones.idTipoPermiso == 3 || informacionAcciones.idTipoPermiso == 12 || informacionAcciones.idTipoPermiso == 11 || informacionAcciones.idTipoPermiso == 16 || informacionAcciones.idTipoPermiso == 17 || informacionAcciones.idTipoPermiso == 25){
            var titulo = "";
            var respuestaSolicitud: ResponseRequest = { status: -1 };
            respuestaSolicitud = await VistaPreviaSolicitudLicencias(informacionAcciones.idPermiso);
            if (respuestaSolicitud.status === 200) {
                var content: any = undefined;
                titulo = "Acción de Personal de Licencia"
                setstateinformacionModalAprobarLicencias({ 
                    url: respuestaSolicitud.dataResponse, 
                    cargando: false, 
                    tituloModal: titulo, 
                    modalContent: content, 
                    idSolicitud:informacionAcciones.idPermiso
                })
    
            }
            else {
                alertService.error(respuestaSolicitud.errorMessage ?? "");
                
    
            }
        }

        
    }

    async function OnClickAccionModalFormulario(idSolicitud) {
        setstateinformacionModalAprobarLicencias({ ...defaultStateModalInformacionValidarLicencias, cargando: true })
        var accionRealizada = await ValidarSolicitudLicencias(idSolicitud)
        setstateinformacionModalAprobarLicencias(defaultStateModalInformacionValidarLicencias)
        await ObtenerDatosSolicitudes();
    }
    


 

    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> {TITULO_APROBACION_SOLICITUDES} </div>
            { tablaSolicitudes }

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de permisos y/o licencias'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

            <ModalRechazo
                show={stateinformacionModalRechazar.idSolicitud > 0 || stateinformacionModalRechazar.cargando}
                size="xl"
                onClose={() => setstateinformacionModalRechazar(defaultStateModalInformacionRechazar)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de permiso y/o licencia?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarPermisos(stateinformacionModalRechazar.idSolicitud, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazar.modalContent}
                tituloModal={"Negar Solicitud de Permisos y/o Licencias"}
                asyncAfterOnClose={() => OnCloseModalRechazo()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}

            />
            <ModalRechazo
                show={stateinformacionModalRechazarParcial.idSolicitud > 0 || stateinformacionModalRechazarParcial.cargando}
                size="xl"
                onClose={() => setstateinformacionModalRechazarParcial(defaultStateModalInformacionRechazar)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar parcialmente la solicitud de permiso y/o licencia?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarParcialPermisos(stateinformacionModalRechazarParcial.idSolicitud, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazarParcial.modalContent}
                tituloModalHTML={
                    <>
                        <div>Negar Parcialmente Solicitud de Permisos y/o Licencias</div>
                        <div style={{ fontSize: '12px', marginTop: '4px', fontStyle: 'italic' }}>
                            Usted puede negar parcialmente una solicitud, solamente si la evidencia no concuerda con los datos de la solicitud.
                        </div>
                    </>
                }
                asyncAfterOnClose={() => OnCloseModalRechazo()}
                labelObservacion={"Indique el motivo de negación parcial"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}

            />

            <ModalConfirmacion
                show={stateinformacionModalAprobarPermisos.idSolicitud > 0 || stateinformacionModalAprobarPermisos.cargando}
                size="xl"
                onClose={() => setstateinformacionModalAprobarPermisos(defaultStateModalInformacionValidarPermisos)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea validar la solicitud de permiso?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => ValidarSolicitudPermisos(stateinformacionModalAprobarPermisos.idSolicitud)}
                contentModal={stateinformacionModalAprobarPermisos.modalContent}
                tituloModal={stateinformacionModalAprobarPermisos.tituloModal}
                asyncAfterOnClose={() => OnCloseModalValidacion()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}

            />

            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalAprobarLicencias.url !== "" || stateinformacionModalAprobarLicencias.cargando}
                onClose={() => setstateinformacionModalAprobarLicencias(defaultStateModalInformacionValidarLicencias)}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalAprobarLicencias.cargando}
                size="xl"
                tituloModal={stateinformacionModalAprobarLicencias.tituloModal}
                urlArchivo={stateinformacionModalAprobarLicencias.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalAprobarLicencias.idSolicitud)}
                disabledbuttonCondition={stateinformacionModalAprobarLicencias.cargando}
                modalContent={stateinformacionModalAprobarLicencias.modalContent}
            />
        </div>
    )

}